(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[343],{

/***/ 3392:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/logos",
      function () {
        return __webpack_require__(485);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ LogosPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1614);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_meta__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1797);
/* harmony import */ var _components_navbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9106);
/* harmony import */ var _components_footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4898);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2699);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_5__);






var Logo = function(param) {
    var name = param.name;
    var url = "/logos/".concat(name);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
        role: "listitem",
        className: "jsx-4c8a9a8e848339b7" + " " + ((name.includes("white") ? "bg-dark" : "") || ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: url + ".svg",
                style: {
                    width: "100%",
                    height: name.includes("vertical") ? 128 : 96
                },
                alt: (0,lodash__WEBPACK_IMPORTED_MODULE_5__.startCase)(name),
                className: "jsx-4c8a9a8e848339b7"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "jsx-4c8a9a8e848339b7",
                children: (0,lodash__WEBPACK_IMPORTED_MODULE_5__.startCase)(name).replace("Bw", " B & W")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-4c8a9a8e848339b7" + " " + "links",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: url + ".svg",
                        className: "jsx-4c8a9a8e848339b7" + " " + "",
                        children: "SVG"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: url + ".png",
                        className: "jsx-4c8a9a8e848339b7" + " " + "",
                        children: "PNG"
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "4c8a9a8e848339b7",
                children: "li.jsx-4c8a9a8e848339b7{margin:0;padding:0;text-align:center}img.jsx-4c8a9a8e848339b7{-webkit-border-radius:12px;-moz-border-radius:12px;border-radius:12px;padding:12px}.bg-dark.jsx-4c8a9a8e848339b7 img.jsx-4c8a9a8e848339b7{background-color:#182342}h2.jsx-4c8a9a8e848339b7{margin-top:16px;font-size:18px}.links.jsx-4c8a9a8e848339b7{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:32px}"
            })
        ]
    });
};
function LogosPage() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: "Logos",
                description: "View & download Watershed\u2019s branding & logos."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navbar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
                    className: "jsx-5c7b0f14f3a9d42f" + " " + "blog-post",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "jsx-5c7b0f14f3a9d42f",
                            children: "Logos"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "jsx-5c7b0f14f3a9d42f",
                            children: [
                                "horizontal-lockup-dark",
                                "horizontal-lockup-white",
                                "horizontal-lockup-bw",
                                "vertical-lockup-dark",
                                "vertical-lockup-white",
                                "vertical-lockup-bw",
                                "mark", 
                            ].map(function(key) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Logo, {
                                    name: key
                                }, key);
                            })
                        }),
                        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default()), {
                            id: "5c7b0f14f3a9d42f",
                            children: "h1.jsx-5c7b0f14f3a9d42f{text-align:center;margin-bottom:48px}ul.jsx-5c7b0f14f3a9d42f{list-style:none;display:grid;grid-gap:48px 24px;margin:0;padding:0}@media(min-width:820px){h1.jsx-5c7b0f14f3a9d42f{font-size:48px}ul.jsx-5c7b0f14f3a9d42f{grid-template-columns:repeat(3,minmax(0,1fr))}}"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_footer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [201,109,854,774,888,179], function() { return __webpack_exec__(3392); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);